import React from 'react'

function Termsofservice() {
    return (
        <div>
            <div class="breadcrumb_section bg_gray page-title-mini">
                <div class="container">
                    <div class="row align-items-center">

                        <div class="page-title">
                            <h1> TERMS OF SERVICE</h1>
                        </div>

                        <div class="col-md-6">

                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="term_conditions">
                                <h3>TERMS & SERVICE</h3>
                                <h6>I: SHIPPING METHOD</h6>
                                <ol>1.PURPOSE:

                                    <ol>Regulating communication and receiving policies, associated with the desire to
                                        create
                                        added value for products when customers choose Harver Electric</ol>
                                </ol>
                                <ol>2.SCOPE OF APPLICATION:

                                    <ol>2.1 Target application:

                                        All end consumers purchase Harver Electric branded products directly at our store
                                        locations.
                                        Customers who are our distributors and agents will apply their own policies.</ol>

                                    <ol>2.2 Application fields:

                                        Free delivery and free operation policy under 5km applies to orders worth 20.65 USD
                                        or more.</ol>
                                </ol>
                                <ol>3.CONTENT:

                                    <ol>3.1 Product receiving service:

                                        Harver Electric provides free home delivery service for customers in the areas
                                        specified in section 2.2 with orders valued at 20.65 USD or more.
                                        Harver Electric will deliver same day if the delivery range is ≤ 15km and the
                                        order
                                        is placed before 10am.
                                        Harver Electric will deliver within 05 - 07 days if customers are outside the
                                        province
                                        Before shipping, the delivery department will contact customers to schedule a
                                        specific time and location for delivery to customers.</ol>
                                </ol>

                                <h6> II: RETURN POLICY</h6>
                                <ol>Policy to return or exchange other products of the same type (same product code)
                                    within 15 days from the date of receipt (based on the Delivery Record) will be
                                    applied free of charge to all Products purchased on Booth with queen, damage due to
                                    manufacturer defect confirmed by a technician or authorized representative of Harver
                                    Electric.
                                </ol>
                                <ol>In case a replacement product is not available at the time you make the exchange,
                                    Harver Electric will recall the defective product and refund you in accordance with
                                    the provisions of this Policy.
                                    When the need to return the Product arises, please contact hotline 18001590 for
                                    support. A technician or authorized representative of Harver Electric will
                                    proactively contact to check the Product and authenticate. Identify the causes of
                                    errors if the product has policy conditions.
                                </ol>

                                <ol>Note:
                                    <ol>-The return policy does not apply to Products that cannot complete the original
                                        accessory set (boxes, boxes, manuals, cables, remote controls...) and/or
                                        accompanying gifts (if any) such as at the time of purchase.
                                    </ol>
                                    <ol>-For Products purchased in discount promotions on the Store: Changes will be
                                        applied
                                        to the product's price policy at the time of purchase.
                                    </ol>
                                    <ol>-For Products purchased in combos (combined product packages): The change will
                                        be
                                        applied to all products in the purchased combo if the products in the combo are
                                        subject to the same return policy conditions. If you want to exchange an order
                                        purchased at a reduced price during the promotion period at Harver Electric, all
                                        products in the order must be exchanged for a refund in order to receive a
                                        refund.
                                        money has been paid.
                                    </ol>
                                </ol>
                                <ol>Policy payment will not be applicable in the following cases:
                                    <ol>-Software errors for washing machine products.
                                    </ol>
                                    <ol>-Use, installation, and maintenance not in accordance with the instructions
                                        attached
                                        to the product.</ol>
                                    <ol>-The product is placed in a dusty, damp place where essence or water enters or
                                        softens the water.
                                    </ol>
                                    <ol>-Dangerous damage due to causes such as (lightning strike...), fire, triangle,
                                        defense, corrosion, oxidation by chemicals, transportation, impact, invasive
                                        objects...</ol>
                                    <ol>-Products, product labels, labels of product components, product models, and machine
                                        numbers are no longer in their original form.</ol>
                                    <ol>-The product has been tampered with or repaired by individuals or organizations not
                                        authorized by Harver Electric.</ol>
                                    <ol>-The product is not 100% guaranteed in its original shape.</ol>
                                    <ol>-Other cases of defects or damage occurring to the Product that are not due to the
                                        manufacturer's fault.</ol>
                                    <ul></ul>

                                </ol>
                                <h6>III: PAYMENT METHODS</h6>
                                <ol>1.1 Payment by bank transfer to the Company's account before the Company delivers the
                                    goods to the buyer.</ol>
                                <ol>Account number:</ol>
                                <ol>0011001648886 at Vietnam Bank for Foreign Trade – Transaction Office</ol>
                                <ol>Account name: Harver Electric Company</ol>
                                <ol>1.2 Cash payment is accepted by the Company on the basis that the Customer commits to
                                    pay cash to the delivery person immediately upon receiving the goods.</ol>
                                <ol>Priority delivery for orders where payment is made by bank transfer before receiving
                                    goods.</ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Termsofservice
